<template>
  <div class="add-profile-wrapper">
    <h1>Podaj kod weryfikacyjny</h1>
    <p>W zależności od ustawień konta, kod potwierdzający twoją
      tożsamość został wysłany na twój telefon bądź e-mail.</p>
    <div>
      <form>
        <label for="verification-code">Kod weryfikacyjny</label>
        <input
          v-model="verificationCode"
          id="verification-code"
          placeholder="Kod z SMS-a lub e-maila..."
          type="text"
          required
        >
      </form>
      <button @click.prevent="addProfile">Wyślij</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProfileVerificationCodeModal",
  methods: {
    addProfile() {
      this.$store.dispatch('addProfile');
      this.$store.commit('hideModal');
      this.$store.dispatch('showLoadingModal', true);
    }
  },
  computed: {
    verificationCode: {
      get() {
        return this.$store.getters.profileToAddInfo.verificationCode;
      },
      set(value) {
        this.$store.commit('updateProfileToAddVerificationCode', value);
      }
    }
  }
};
</script>
